export class RouteRegistry {
    _routes;
    constructor() {
        this._routes = Object.freeze([]);
    }
    add(routes, shell) {
        // Create a new array so the routes array is immutable.
        this._routes = Object.freeze([
            ...this._routes,
            ...routes.filter(x => shell === undefined || x['targetShells'] === undefined || x.targetShells.includes(shell)),
        ]);
    }
    get routes() {
        return this._routes;
    }
}
